import { VisxText } from '@/components/VisxText';
import { useTheme } from '@simplywallst/ui-core';
import { Group } from '@visx/group';
import { getStringWidth } from '@visx/text';

type Props = {
  label: string;
  color: string;
  x: number;
  y: number;
  chartWidth: number;
};

const PADDING_X = 4;
const PADDING_Y = 4;
const FONT_SIZE = 12; // Same as tiny

export const TimeseriesTooltip = ({
  label,
  color,
  x,
  y,
  chartWidth,
}: Props) => {
  const theme = useTheme();
  const width = getStringWidth(label, {
    fontSize: FONT_SIZE,
  });
  const totalWidth = (width ?? 0) + 2 * PADDING_X;
  const totalHeight = FONT_SIZE + 2 * PADDING_Y;
  const halfWidth = totalWidth / 2;
  const adjustedX = Math.min(Math.max(halfWidth, x), chartWidth - halfWidth); // Prevents horizontal overflow
  return (
    <Group left={adjustedX - halfWidth} top={y - totalHeight / 2}>
      <rect
        x={0}
        y={0}
        width={totalWidth}
        height={totalHeight}
        fill={theme.color.charcoalRGBA(0.8)}
        rx={4}
        ry={4}
        className="overflow-visible"
      />
      <VisxText
        x={PADDING_X}
        y={PADDING_Y}
        dy="0.1em"
        verticalAnchor="start"
        typography="tiny"
        fill={color}
      >
        {label}
      </VisxText>
    </Group>
  );
};
